export default "<ng-content select=\"app-page-header\"></ng-content>\n<div main>\n\t<ng-content></ng-content>\n</div>\n"